import Stack from "@casino/legacy/client/shared/Stack";
import ProtectedByRecaptcha from "../../ProtectedByRecaptcha";
import ForgotPasswordLink from "../../Shared/ForgotPasswordLink";
import CreateAccountLink from "./CreateAccountLink";

type Props = {
  isPopover?: boolean;
};
const LoginBottomLinks: FC<Props> = ({ isPopover }) => (
  <Stack space="small" alignContent="start">
    <ForgotPasswordLink />
    <CreateAccountLink isPopover={isPopover} />
    <ProtectedByRecaptcha />
  </Stack>
);

export default LoginBottomLinks;
